import createComponent from '@carvana/merch-components/createComponent';

export const Content = createComponent('div', {
  className: 'flex flex-1 flex-col gap-xl'
});

export const ImageArea = createComponent('div', {
  className: 'aspect-video w-full shrink-0 overflow-hidden rounded-sm'
});

export const ImagePlaceholder = createComponent('div', {
  className:
    'size-full rounded-md bg-background-weak flex items-center justify-center'
});

export const ImageUnavailable = createComponent('div', {
  className:
    'h-full flex items-center justify-center text-center text-text-disabled t-body-sm'
});

export const OptionName = createComponent('span', {
  className: 'min-w-0 text-text-strong t-heading-xs'
});

export const PriceAdd = createComponent('span', {
  className: 'mt-auto shrink-0 text-text-strong t-heading-xs'
});

export const StockCount = createComponent('p', {
  className: 'text-text-default t-body-sm'
});
